import { useTranslation } from 'react-i18next';

import { EmailAction } from '@/shared/types/action';

const Email = ({ action }: { action: EmailAction }) => {
  const { t } = useTranslation();
  const subject = action.subject ?? '';

  return (
    <>
      <span className="text-sm leading-5 font-semibold text-foreground-muted">
        {t('actions.email.subject')}
      </span>
      <span className="text-sm leading-5 font-normal text-foreground-muted">{subject}</span>
    </>
  );
};

export default Email;
